module.exports = __webpack_public_path__ + "img/nt55-01-80-1d.prt.ea84fd76.jpg";